import classNames from 'classnames';
import { eventNames } from 'configuration/eventNames';
import orderBy from 'lodash/orderBy';
import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { firebaseAnalyticsNO } from '../../firebase';
import PoweredByComponent from '../PoweredByComponent';

export default function NewMenuItem({
  data, // optional
  history,
  location,
  showMenuItemHandler,
  showHalfViewHandler, // optional
  itemType,
  category, // optional

  specialClass, // optional
  item, // optional
  productName, // optional
  lazyLoad, // optional
  bgImgSrc, // optional
  ingredients, // optional
  imgSrc, // optional
  itemHandler, // optional

  // price,
  // slideIndex,
  // activeSlideIndex,
  // initiateDesktopLoyaltyFlow,
  // soldOutMenuItems,
}) {
  const [list, setList] = useState([]);

  const {
    soldOutMenuItems,
    specialFilter: { isSpecialFilterApplied, spMenuSizes },
  } = useSelector((state) => state.homeReducer);
  const { halfHalfSetup } = useSelector((state) => state.layoutReducer);

  const getPriceForDisplay = useCallback(
    (item) => {
      // if (!soldOutMenuItems) return '';

      if (item.selectedSizes && item.selectedSizes.length > 0) {
        let isSoldOut = !!soldOutMenuItems;
        if (soldOutMenuItems) {
          isSoldOut =
            item.itemType === 1
              ? item.selectedModifiers.some((j) =>
                  j.subModifiers.every((sm) => {
                    const basesSoldOut =
                      soldOutMenuItems.findIndex(
                        (k) =>
                          k.smId === sm._id &&
                          k.menuItemId === item._id &&
                          k.variantId === null
                      ) !== -1;

                    const variants = sm.variants || [];

                    const variantsSoldOut =
                      variants.lenth === 0
                        ? false
                        : (sm.variants || []).every(
                            (v) =>
                              soldOutMenuItems.findIndex(
                                (l) =>
                                  l.smId === sm._id &&
                                  l.menuItemId === item._id &&
                                  l.variantId === v._id
                              ) !== -1
                          );

                    return basesSoldOut && variantsSoldOut;
                  })
                )
              : item.selectedSizes.every((s) => {
                  const basesSoldOut =
                    soldOutMenuItems.findIndex(
                      (k) =>
                        k.smId === s._id &&
                        k.menuItemId === item._id &&
                        k.variantId === null
                    ) !== -1;

                  const variants = s.variants || [];

                  const variantsSoldOut =
                    variants.lenth === 0
                      ? false
                      : (s.variants || []).every(
                          (v) =>
                            soldOutMenuItems.findIndex(
                              (k) =>
                                k.smId === s._id &&
                                k.menuItemId === item._id &&
                                k.variantId === v._id
                            ) !== -1
                        );

                  return basesSoldOut && variantsSoldOut;
                });
        }

        if (isSoldOut) return 'Sold Out';

        if (isSpecialFilterApplied) {
          let featureSizes = item.selectedSizes.filter((obj) => {
            return spMenuSizes.map((m) => m._id).includes(obj._id);
          });
          if (featureSizes.length > 0) {
            return (
              featureSizes[0].name.substring(0, 1) +
              ' ' +
              Number(featureSizes[0].price).toFixed(2)
            );
          } else return Number(item.selectedSizes[0].price).toFixed(2);
        } else {
          let featureSizes = item.selectedSizes.filter((obj) => {
            return obj.isFeaturedSize === true;
          });
          if (featureSizes.length > 0) {
            return featureSizes[0].isAbbreviationShow
              ? featureSizes[0].name.substring(0, 1) +
                  ' ' +
                  Number(featureSizes[0].price).toFixed(2)
              : Number(featureSizes[0].price).toFixed(2);
          } else return Number(item.selectedSizes[0].price).toFixed(2);
        }
      } else {
        if (item.type === '1') {
          return item.cost;
        } else {
          return '';
        }
      }
    },
    [isSpecialFilterApplied, soldOutMenuItems, spMenuSizes]
  );

  useEffect(() => {
    let newList = [];
    if (
      category &&
      halfHalfSetup &&
      halfHalfSetup.halfHalfs &&
      halfHalfSetup.halfHalfs.length > 0
    ) {
      let matchingHalfCategories = halfHalfSetup.halfHalfs.filter((item) => {
        return item.categories.map((c) => c._id).includes(category._id);
      });
      if (matchingHalfCategories.length > 0) {
        let obj = {};
        obj.history = history;
        obj.location = location;
        obj.itemType = 'halfhalf';
        obj.item = matchingHalfCategories[0];
        obj.displayOrder = -1;
        obj.totalRevenue = 1000000000000;
        obj.lazyLoad = false;
        obj.itemHandler = showHalfViewHandler;
        obj.imgSrc = specialClass
          ? `https://s3-ap-southeast-2.amazonaws.com/lacampa/assets/spPlaceholder.jpg`
          : `https://s3-ap-southeast-2.amazonaws.com/lacampa/assets/placeholder.jpg`;
        obj.bgImgSrc = halfHalfSetup.halfHalfPlaceholderImage
          ? halfHalfSetup.halfHalfPlaceholderImage
          : `https://s3-ap-southeast-2.amazonaws.com/lacampa/assets/placeholder.jpg`;
        obj.key = `halhalk23set`;
        obj.showName = true;
        obj.productName = 'HALF / HALF';
        obj.ingredients = matchingHalfCategories[0].categories
          .map((c) => c.name)
          .join('/');
        newList.push(obj);
      }

      data &&
        data.map((item, index) => {
          let obj = {};
          obj.history = history;
          obj.location = location;
          obj.itemType = itemType;
          obj.item = item;
          obj.displayOrder = item.displayOrder ? item.displayOrder : 0;
          obj.totalRevenue = item.totalRevenue ? item.totalRevenue : 0;
          obj.lazyLoad = false;
          obj.itemHandler = showMenuItemHandler;
          obj.imgSrc = specialClass
            ? `https://s3-ap-southeast-2.amazonaws.com/lacampa/assets/spPlaceholder.jpg`
            : `https://s3-ap-southeast-2.amazonaws.com/lacampa/assets/placeholder.jpg`;
          obj.bgImgSrc = item.urlS3 ? item.urlS3 : item.url;
          obj.key = index;
          obj.price = getPriceForDisplay(item);
          obj.showName = !item.isNameHidden;
          obj.productName = item.name;
          obj.ingredients = item.displayName
            ? item.displayName &&
              item.displayName.length > (window.innerWidth > 340 ? 40 : 25)
              ? item.displayName
                  .substr(0, window.innerWidth > 340 ? 30 : 20)
                  .substr(
                    0,
                    Math.min(
                      item.displayName.substr(
                        0,
                        window.innerWidth > 340 ? 30 : 20
                      ).length,
                      item.displayName
                        .substr(0, window.innerWidth > 340 ? 30 : 20)
                        .lastIndexOf(' ')
                    )
                  ) + '...'
              : item.displayName
            : item.description &&
              item.description.length > (window.innerWidth > 340 ? 40 : 25)
            ? item.description
                .substr(0, window.innerWidth > 340 ? 30 : 20)
                .substr(
                  0,
                  Math.min(
                    item.description.substr(
                      0,
                      window.innerWidth > 340 ? 30 : 20
                    ).length,
                    item.description
                      .substr(0, window.innerWidth > 340 ? 30 : 20)
                      .lastIndexOf(' ')
                  )
                ) + '...'
            : item.description;
          newList.push(obj);
          return item;
        });
    } else {
      data &&
        data.map((item, index) => {
          let obj = {};
          obj.history = history;
          obj.location = location;
          obj.itemType = itemType;
          obj.item = item;
          obj.displayOrder = item.displayOrder;
          obj.totalRevenue = item.totalRevenue;
          obj.lazyLoad = false;
          obj.itemHandler = showMenuItemHandler;
          obj.imgSrc = specialClass
            ? `https://s3-ap-southeast-2.amazonaws.com/lacampa/assets/spPlaceholder.jpg`
            : `https://s3-ap-southeast-2.amazonaws.com/lacampa/assets/placeholder.jpg`;
          obj.bgImgSrc = item.urlS3 ? item.urlS3 : item.url;
          obj.key = index;
          obj.showName = !item.isNameHidden;
          obj.price = getPriceForDisplay(item);
          obj.productName = item.name;
          obj.ingredients = item.displayName
            ? item.displayName &&
              item.displayName.length > (window.innerWidth > 340 ? 40 : 25)
              ? item.displayName
                  .substr(0, window.innerWidth > 340 ? 30 : 20)
                  .substr(
                    0,
                    Math.min(
                      item.displayName.substr(
                        0,
                        window.innerWidth > 340 ? 30 : 20
                      ).length,
                      item.displayName
                        .substr(0, window.innerWidth > 340 ? 30 : 20)
                        .lastIndexOf(' ')
                    )
                  ) + '...'
              : item.displayName
            : item.description &&
              item.description.length > (window.innerWidth > 340 ? 40 : 25)
            ? item.description
                .substr(0, window.innerWidth > 340 ? 30 : 20)
                .substr(
                  0,
                  Math.min(
                    item.description.substr(
                      0,
                      window.innerWidth > 340 ? 30 : 20
                    ).length,
                    item.description
                      .substr(0, window.innerWidth > 340 ? 30 : 20)
                      .lastIndexOf(' ')
                  )
                ) + '...'
            : item.description;
          newList.push(obj);
          return item;
        });
    }
    if (
      (category && category.sortingType === '2') ||
      (itemType && itemType === 'specials')
    ) {
      newList = orderBy(newList, ['displayOrder'], ['asc']);
    } else {
      newList = orderBy(newList, ['totalRevenue'], ['desc']);
    }

    if (data) {
      const filteredSoldOutMenuItems = soldOutMenuItems ? soldOutMenuItems : [];

      data.forEach((item) => {
        if (item.itemType === 0) {
          let count = 0;
          item.selectedSizes.forEach((selectedSize) => {
            filteredSoldOutMenuItems.forEach((soldOutItem) => {
              if (item._id === soldOutItem.menuItemId) {
                if (
                  soldOutItem.smId === selectedSize._id &&
                  soldOutItem.variantId === null
                ) {
                  selectedSize.availability = false;
                  count++;
                }
                if (
                  soldOutItem.smId === selectedSize._id &&
                  soldOutItem.variantId !== null
                ) {
                  selectedSize.variants.forEach((variant) => {
                    if (variant._id === soldOutItem.variantId) {
                      variant.availability = false;
                    }
                  });
                }
              }
            });
          });
          if (count === item.selectedSizes.length) {
            // item.isAvailable = false;
            return false;
          } else {
            return true;
          }
        }
        if (item.itemType === 1) {
          let count = 0;
          item.selectedModifiers.forEach((modifier) => {
            modifier.subModifiers.forEach((subModifier) => {
              count++;
              if (subModifier.variants) {
                subModifier.variants.forEach((variant) => {
                  count++;
                });
              }
            });
          });
          let filteredItems = filteredSoldOutMenuItems.filter(
            (soldOutItem) => soldOutItem.menuItemId === item._id
          );

          if (count === filteredItems.length && count !== 0) {
            // item.isAvailable = false;
            return false;
          } else {
            return true;
          }
        }
      });
    }

    setList(newList);
  }, [
    category,
    data,
    halfHalfSetup,
    history,
    itemType,
    location,
    showHalfViewHandler,
    showMenuItemHandler,
    soldOutMenuItems,
    specialClass,
    getPriceForDisplay,
  ]);

  // const getClassName = () => {
  //   if (activeSlideIndex === slideIndex) {
  //     return (
  //       'md-' + slideIndex + ' ' + specialClass && specialClass + ' active'
  //     );
  //   } else if (
  //     activeSlideIndex === slideIndex - 1 ||
  //     activeSlideIndex === slideIndex + 1
  //   )
  //     return 'sibling md-' + slideIndex + ' ' + specialClass;
  //   else return 'md-' + slideIndex + ' ' + specialClass;
  // };

  const getSpecialAvailability = (item) => {
    let returnString = '';
    let finalString = '';
    let dayStringArray = [];
    if (item.isAvailableDelivery && item.isAvailablePickup) returnString = '';
    else if (!item.isAvailableDelivery && item.isAvailablePickup)
      returnString = '(Pickup only';
    else if (item.isAvailableDelivery && !item.isAvailablePickup)
      returnString = '(Delivery only';

    if (item.Monday)
      dayStringArray.push({ index: 1, isAvailable: true, display: 'Mon' });

    if (item.Tuesday)
      dayStringArray.push({ index: 2, isAvailable: true, display: 'Tue' });

    if (item.Wednesday)
      dayStringArray.push({ index: 3, isAvailable: true, display: 'Wed' });

    if (item.Thursday)
      dayStringArray.push({ index: 4, isAvailable: true, display: 'Thu' });

    if (item.Friday)
      dayStringArray.push({ index: 5, isAvailable: true, display: 'Fri' });

    if (item.Saturday)
      dayStringArray.push({ index: 6, isAvailable: true, display: 'Sat' });

    if (item.Sunday)
      dayStringArray.push({ index: 7, isAvailable: true, display: 'Sun' });

    let expected;
    let dayString = '';
    dayStringArray.forEach((dayObj, index) => {
      if (index === 0) {
        dayString = dayString + dayObj.display;
        expected = dayObj.index + 1;
        return;
      }

      if (dayObj.index === expected) {
        expected = dayObj.index + 1;
        dayString = dayString + '-' + dayObj.display;
      } else {
        expected = dayObj.index + 1;
        dayString = dayString + ',' + dayObj.display;
      }
    });
    let newDayString = '';
    let dayStringArr = dayString.split(',');
    if (dayStringArray.length !== 7) {
      if (dayStringArr.length > 1) {
        dayStringArr.forEach((dayStringElem) => {
          if (dayStringElem.indexOf('-') !== -1) {
            let dashArray = dayStringElem.split('-');
            newDayString = dashArray[0] + '-' + dashArray[dashArray.length - 1];
          } else {
            newDayString = newDayString + ',' + dayStringElem;
          }
        });
      } else {
        let dashArray = dayStringArr[0].split('-');
        newDayString = dashArray[0] + '-' + dashArray[dashArray.length - 1];
      }
    }
    if (returnString.length > 0 && newDayString.length > 0)
      finalString = returnString + ',' + newDayString + ')';
    else if (returnString.length > 0 && newDayString.length === 0)
      finalString = returnString + ')';
    else if (returnString.length === 0 && newDayString.length > 0)
      finalString = '(' + newDayString + ')';
    return finalString.length > 10
      ? finalString.substr(0, 10) + '..'
      : finalString;
  };

  const setOrderItem = (e, pathname, isAvailable, itemType, item) => {
    e.preventDefault();
    if (item.item) {
      item.itemHandler(item.item);
    }
  };

  const setFilteredOrderItem = (e, isSoldOut) => {
    e.preventDefault();
    if (item) {
      itemHandler?.({ ...item, isSoldOut });
    }
  };

  const renderMenuItem = (menuItem, item) => {
    let sectionStyle = {
      backgroundImage: `url(${item.bgImgSrc})`,
    };

    // let disableClickClass = classNames({
    // 'disable-click': item.price === 'Sold Out',
    // });
    let halfHalfClass = classNames({
      imgWrap: true,
      'swiper-lazy': menuItem.lazyLoad,
    });

    const eventName =
      item.itemType === 'specials'
        ? eventNames.SPECIALS_MENU_ITEM_OPENED
        : null;

    return (
      <li name={item.productName} className='itemBoxes boxWrapper'>
        <div
          className='itemInnerWrap'
          style={{
            pointerEvents: item.price === 'Sold Out' ? 'none' : 'initial',
          }}
        >
          <div
            className={halfHalfClass}
            data-background={item.bgImgSrc}
            style={item.lazyLoad ? { visibility: 'visible' } : sectionStyle}
          >
            <img src={item.imgSrc} alt='img' className='proimg' />
            <div className='prodInfo'>
              {item.price && item.item.type !== '2' && (
                <div
                  className={
                    !item.item.isAvailable &&
                    (item.itemType === 'menuitem' ||
                      item.itemType === 'specials') &&
                    item.price === 'Sold Out'
                      ? 'prodPrice redFont text-capitalize'
                      : 'prodPrice text-capitalize'
                  }
                >
                  {item.price}
                </div>
              )}
              {(typeof item.showName === `undefined` || !!item.showName) && (
                <div className='prodname'>
                  {item.productName.indexOf(' ') === -1 &&
                  item.productName.length > 10
                    ? item.productName.match(/.{1,10}/g).join('­')
                    : item.productName}
                </div>
              )}
            </div>
          </div>
          <div className='prodIngredients'>
            <span className='innerIng text-capitalize'>
              {item.ingredients.length > 25
                ? item.ingredients.substr(0, 25) + '...'
                : item.ingredients}
              {item &&
                item.itemType &&
                item.itemType === 'specials' &&
                getSpecialAvailability(item.item)}
            </span>
          </div>
          {item.itemType && item.itemType === 'halfhalf' ? (
            <a
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                // XXX: dirty hack to prevent menu items opening while swiping
                const tabTransform =
                  e.target.parentElement.parentElement.parentElement
                    .parentElement.parentElement.style.transform;
                const tabFullyTranslated =
                  tabTransform === `translate3d(0%, 0px, 0px)` ||
                  window.Cypress;

                if (tabFullyTranslated) {
                  firebaseAnalyticsNO.logEvent(
                    eventName || eventNames.HALF_HALF_MENU_ITEM_OPENED,
                    { name: item.item.name }
                  );
                  setOrderItem(
                    e,
                    item.item.name
                      ? `/${item.itemType}/${item.item.name
                          .trim()
                          .replace(/ /g, '')
                          .toLowerCase()}${item.item._id}`
                      : '',
                    item.item.isAvailable,
                    item.itemType,
                    item
                  );
                }
              }}
              href={
                item.item.name &&
                `/${item.itemType}/${item.item.name
                  .trim()
                  .replace(/ /g, '')
                  .toLowerCase()}${item.item._id}`
              }
            >
              {item.productName}
            </a>
          ) : (
            <a
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                // XXX: dirty hack to prevent menu items opening while swiping
                const tabTransform =
                  e.target.parentElement.parentElement.parentElement
                    .parentElement.parentElement.style.transform ||
                  e.target.parentElement.parentElement.parentElement
                    .parentElement.parentElement.parentElement.style.transform;
                const tabFullyTranslated =
                  tabTransform === `translate3d(0%, 0px, 0px)` ||
                  window.Cypress;

                if (tabFullyTranslated) {
                  firebaseAnalyticsNO.logEvent(
                    eventName || eventNames.MENU_ITEM_OPENED,
                    {
                      name: item.item.name,
                    }
                  );
                  setOrderItem(
                    e,
                    `/${item.itemType}/${item.item.name
                      .trim()
                      .replace(/ /g, '')
                      .toLowerCase()}${item.item._id}`,
                    item.item.isAvailable,
                    item.itemType,
                    item
                  );
                }
              }}
              href={
                item.item.name &&
                `/${item.itemType}/${item.item.name
                  .trim()
                  .replace(/ /g, '')
                  .toLowerCase()}${item.item._id}`
              }
              // className={disableClickClass}
            >
              {item.showName && item.productName}
            </a>
          )}
        </div>
      </li>
    );
  };

  const renderFilteredMenuItem = () => {
    let sectionStyle = {
      backgroundImage: `url(${bgImgSrc})`,
    };

    // let disableClickClass = classNames({
    // 'disable-click': item.isAvailable === false,
    // });
    const itemPrice = getPriceForDisplay(item);

    return (
      <div name={productName} className='itemBoxes'>
        <div
          className='itemInnerWrap'
          style={{
            pointerEvents: itemPrice === 'Sold Out' ? 'none' : 'initial',
          }}
        >
          <div
            className={lazyLoad ? 'imgWrap swiper-lazy' : 'imgWrap'}
            data-background={bgImgSrc}
            style={lazyLoad ? { visibility: 'visible' } : sectionStyle}
          >
            <img src={imgSrc} alt='img' className='proimg' />
            <div className='prodInfo'>
              {itemPrice === 'Sold Out' && (
                <div className={'prodPrice redFont text-capitalize'}>
                  {'Sold Out'}
                </div>
              )}
              {Number(item?.upsale) > 0 && itemPrice !== 'Sold Out' && (
                <div className={'prodPrice redFont text-capitalize'}>
                  {`+ ${item.upsale}`}
                </div>
              )}
              {(typeof item?.showName === `undefined` || !!item?.showName) && (
                <div className='prodname'>
                  {productName?.indexOf(' ') === -1 && productName?.length > 10
                    ? productName.match(/.{1,10}/g).join('­')
                    : productName}
                </div>
              )}
            </div>
          </div>
          <div className='prodIngredients'>
            <span className='innerIng  text-capitalize'>{ingredients}</span>
          </div>
          {itemType === 'halfhalf' ? (
            <a
              onClickCapture={(e) =>
                setFilteredOrderItem(e, itemPrice === 'Sold Out')
              }
              href={
                item.name &&
                `/${itemType}/${item.name
                  .trim()
                  .replace(/ /g, '')
                  .toLowerCase()}${item._id}`
              }
              // className={disableClickClass}
            >
              {productName}
            </a>
          ) : (
            <a
              onClick={(e) => setFilteredOrderItem(e, itemPrice === 'Sold Out')}
              href={
                item.name &&
                `/${itemType}/${item.name
                  .trim()
                  .replace(/ /g, '')
                  .toLowerCase()}${item._id}`
              }
              // className={disableClickClass}
            >
              {productName}
            </a>
          )}
        </div>
      </div>
    );
  };

  if (itemType === 'menuitem' || itemType === 'specials') {
    return list.length > 0 ? (
      <div className='container-menu-item'>
        {specialClass ? (
          <div className='specialsSlide'>
            <ul style={{ listStyleType: 'none' }}>
              {list.map((menuItem, index) => {
                let item = {
                  bgImgSrc: menuItem.bgImgSrc,
                  lazyLoad: menuItem.lazyLoad,
                  imgSrc: menuItem.imgSrc,
                  price: menuItem.price,
                  productName: menuItem.productName || menuItem.name,
                  showName: menuItem.showName,
                  ingredients: menuItem.ingredients,
                  itemType: menuItem.itemType,
                  item: menuItem.item,
                  location: menuItem.location,
                  history: menuItem.history,
                  itemHandler: menuItem.itemHandler,
                };
                return (
                  <React.Fragment key={index}>
                    {renderMenuItem(menuItem, item)}
                  </React.Fragment>
                );
              })}
            </ul>
          </div>
        ) : (
          <React.Fragment>
            <ul style={{ listStyleType: 'none', paddingLeft: '0px' }}>
              {list.map((menuItem, index) => {
                let item = {
                  bgImgSrc: menuItem.bgImgSrc,
                  lazyLoad: menuItem.lazyLoad,
                  imgSrc: menuItem.imgSrc,
                  price: menuItem.price,
                  productName: menuItem.productName,
                  showName: menuItem.showName,
                  ingredients: menuItem.ingredients,
                  itemType: menuItem.itemType,
                  item: menuItem.item,
                  location: menuItem.location,
                  history: menuItem.history,
                  itemHandler: menuItem.itemHandler,
                };
                return (
                  <React.Fragment key={index}>
                    {renderMenuItem(menuItem, item)}
                  </React.Fragment>
                );
              })}
            </ul>
          </React.Fragment>
        )}
        <PoweredByComponent />
      </div>
    ) : null;
  } else if (itemType === 'halfhalfitem' || itemType === 'specialitem') {
    return <React.Fragment>{renderFilteredMenuItem()}</React.Fragment>;
  }
}
